module.exports = __webpack_public_path__ + "static/img/dj1-1.72693ad.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/layout/dj1-1.png
// module id = 784
// module chunks = 0